import React from 'react';

class RouteErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    console.error('Route render error:', error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="rounded-lg border border-red-200 bg-red-50 p-8 text-center">
          <h2 className="text-xl font-semibold text-red-900 mb-4">This page failed to load</h2>
          <p className="text-red-800 mb-4">An unexpected error occurred while rendering this page.</p>
          <a href="/dashboard" className="text-blue-600 hover:underline font-medium">
            Back to Dashboard
          </a>
          <button
            type="button"
            className="ml-4 text-sm text-gray-600 hover:text-gray-900 underline"
            onClick={() => this.setState({ hasError: false })}
          >
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default RouteErrorBoundary;
